import { Button, Modal } from 'rsuite';
import styles from './ModalConfirmarExclusao.module.scss';

type ModalConfirmarExclusaoProps = {
  show: boolean;
  nomeMonitoramento?: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const ModalConfirmarExclusao = ({ show, nomeMonitoramento, onClose, onConfirm }: ModalConfirmarExclusaoProps) => (
  <Modal className={styles.modal} size="xs" show={show} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title className={styles.title}>Excluir monitoramento</Modal.Title>
    </Modal.Header>
    <Modal.Body className={styles.body}>
      <p>
        Tem certeza que deseja excluir o monitoramento <strong>{nomeMonitoramento}</strong>? Essa ação não pode ser desfeita.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} appearance="ghost">
        Cancelar
      </Button>
      <Button onClick={onConfirm} appearance="primary" color="red">
        Excluir
      </Button>
    </Modal.Footer>
  </Modal>
);
